import { Grid, Tabs } from '@mantine/core';
import { PreferenceAccountCard } from './PreferenceAccountCard';
import { PreferenceMarketingCard } from './PreferenceMarketingCard';
import { PreferencePrivacyCard } from './PreferencePrivacyCard';
export const AccountPreferenceTab: React.FC = () => {
  return <Tabs.Panel value="preferences">
      <Grid gutter={20}>
        <Grid.Col span={{
        base: 12,
        lg: 6
      }}>
          <PreferenceAccountCard />
        </Grid.Col>
        <Grid.Col span={{
        base: 12,
        lg: 6
      }}>
          <PreferencePrivacyCard />
        </Grid.Col>
        <Grid.Col span={12}>
          <PreferenceMarketingCard />
        </Grid.Col>
      </Grid>
    </Tabs.Panel>;
};